import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Button, ButtonGroup, useTheme } from '@mui/material';
import React from 'react';

interface IProps {
  label: string | React.ReactNode;
  onClick: () => void;
  onMenuOpen: (event: React.MouseEvent<HTMLElement>) => void;
  variant?: 'text' | 'outlined' | 'contained';
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  dataAction?: string;
  menuDataAction?: string;
}

export const SplitButton: React.FC<IProps> = ({
  label,
  onClick,
  onMenuOpen,
  variant = 'outlined',
  size = 'medium',
  disabled = false,
  dataAction,
  menuDataAction,
}) => {
  const theme = useTheme();
  const accentColor = theme.wl?.portal_accent_color || theme.palette.primary.main;

  return (
    <ButtonGroup variant={variant} aria-label="split button actions" disabled={disabled}>
      <Button
        onClick={onClick}
        size={size}
        data-action={dataAction}
        sx={{
          flex: 1,
          textTransform: 'none',
          fontSize: 13,
          borderColor: accentColor,
          color: accentColor,
          padding: '4px 7px',
        }}
      >
        {label}
      </Button>
      <Button
        size="small"
        aria-label="select action"
        aria-haspopup="menu"
        onClick={onMenuOpen}
        data-action={menuDataAction}
        sx={{
          borderColor: accentColor,
          color: accentColor,
        }}
      >
        <KeyboardArrowDownIcon sx={{ width: 18, height: 18 }} />
      </Button>
    </ButtonGroup>
  );
};
